import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { abortTutorial } from "../joyrideStepHelpers";
import { consumeSkipNextPop } from "./skipTutorialAbortOnNextPop";

interface Options {
    warehouseTutorialActive: boolean;
    onAbort?: () => void;
}

export const useStopTutorialOnPop = ({ warehouseTutorialActive, onAbort }: Options) => {
    const location = useLocation();
    const navType = useNavigationType();
    const firstRunRef = useRef(true);

    useEffect(() => {
        if (firstRunRef.current) {
            firstRunRef.current = false;
            return;
        }
        if (!warehouseTutorialActive) return;
        if (navType !== "POP") return;
        if (consumeSkipNextPop()) return;

        abortTutorial();
        onAbort?.();
    }, [location.key, navType, warehouseTutorialActive, onAbort]);
};
